angular.module('domain.mail', ['upResources', 'security.authorization', 'ui.router']).config([
	'$stateProvider',
	function ($stateProvider) {
		authUser.$inject = ['$routeGuard'];
		function authUser($routeGuard) {
			return $routeGuard.requireUser();
		}

		$stateProvider
			.state('mailCampaign', {
				abstract: true,
				template: '<div></div>',
				url: '/:customerId/mail-campaign/:id/',
				section: 'market',
				resolve: {
					authUser: authUser
				}
			})
			.state('mailCampaign.dashboard', {
				template: '',
				url: '',
				section: 'market'
			})
			.state('mailCampaign.visits', {
				template: '',
				url: 'visits',
				section: 'market'
			})
			.state('mailCampaign.submits', {
				template: '',
				url: 'submits',
				section: 'market'
			})
			.state('mailCampaign.recipients', {
				template: '',
				url: 'recipients?filter&drill',
				section: 'market'
			})
			.state('listMailTemplates', {
				url: '/:customerId/mail/templates/'
			});
	}
]);
